import type { AppDispatch } from '../../../store';
import type { NodeBase } from '../../../entities/Node';
import { moveCategoryNode } from '../category/moveCategory';

interface PasteMoveCategoryParams {
  newNode: NodeBase;
  targetNode: NodeBase;
  prevParentId: string;
  nextChildIndex: number;
}

interface PasteMoveCategoryResult {
  nodesText: string;
}

export const pasteMoveCategory = async (
  dispatch: AppDispatch,
  { newNode, targetNode, prevParentId, nextChildIndex }: PasteMoveCategoryParams,
): Promise<PasteMoveCategoryResult> => {
  await dispatch(
    moveCategoryNode({
      node: newNode,
      nextChildIndex,
      nextParentNode: targetNode,
      prevParentId,
    }),
  );

  return {
    nodesText: newNode.category.globalCategoryName,
  };
};
